import { Result } from '@standardnotes/domain-core';
export class GetVaultItems {
    constructor(items) {
        this.items = items;
    }
    execute(vault) {
        return Result.ok(this.items.items.filter((item) => item.key_system_identifier === vault.systemIdentifier));
    }
}
